/** 三端登录校验
 * 登录成功，会自动执行需要登录后刷新的操作，如产品库相关页面会请求产品当前项目信息；
 * 插件登录成功后，会将token存起来，以模拟插件端调用后端接口；
 * G插件的qa环境，需要进行假登录，来模拟插件端调用后端接口；
 * **/
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { GetGdcAccessToken, CreateBrowser, } from '@/core/gcsUtils'
import afterLoginMixin from '@/mixins/afterLoginMixin'
import { checkExistFile, readUserToFile, writeUserToFile, loginCachePath, deleteFile } from '@/core/desktopCache'

export default {
  mixins: [afterLoginMixin],
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      language: 'language',
      user: 'user/user',
      userToken: 'user/userToken',
    }),
    ignoreLogin() {
      return !!(this.$route.meta && this.$route.meta.ignoreLogin)
    },
  },
  methods: {
    ...mapMutations({
      setShowRLoginButton: 'setShowRLoginButton',
      setUserToken: 'user/setUserToken',

    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
    }),
    // 三端判断用户是否登录的公共方法
    async checkLogin(inToken) {
      if (this.platform === 'r') {
        try {
          const { data: isLogin } = await this.$revitClient.IsUserLoggedIn()
          // 如果登录了，就将token存起来
          if (isLogin) {
            const { data: token } = await this.$revitClient.GetAccessToken()
            this.setUserToken(token)
            // 执行登录后的相关初始化操作
            await this.afterLoginFn()
          } else {
            this.setUserToken(null)
          }
          return !!isLogin
        } catch (error) {
          return false
        }
      } else if (this.platform === 'g' && this.softwareCode !== 'AppGbr') {
        try {
          const { data: gToken } = await GetGdcAccessToken()
          await this.loadUserInfo({ Authorization: `Bearer ${gToken}` })
          if (this.language === 'en_HK' || (this.user && this.user.id)) {
            this.setUserToken(gToken)
            // 执行登录后的相关初始化操作
            await this.afterLoginFn()
            return !!gToken
          }
          this.setUserToken(null)
          return false
        } catch (error) {
          return false
        }
      } else if (this.platform === 'cs') {
        return await this.customLogin(inToken)
      } else if (this.softwareCode === 'AppGbr') {
        try {
          const data = await this.$desktopClient.GetUserInfo()
          if (data.code === 'success' && data.data.accessToken) {
            const gToken = data.data.accessToken
            await this.loadUserInfo({ Authorization: `Bearer ${gToken}` })
            this.setUserToken(gToken)
            // 执行登录后的相关初始化操作
            await this.afterLoginFn()
            return !!gToken
          } else {
            return await this.customLogin(inToken)
          }
        } catch (error) {
          return await this.customLogin(inToken)
        }
      } else {
        // web端
        try {
          await this.loadUserInfo()
          this.setUserToken(null)
          // 执行登录后的相关初始化操作
          await this.afterLoginFn()
          return !!this.user.strId
        } catch (err) {
          return false
        }
      }
    },
    async customLogin(inToken) {
      try {
        if (await checkExistFile(loginCachePath()) === true) {
          const fileContext = await readUserToFile()
          if (fileContext && fileContext !== false) {
            const { isLogin, token } = JSON.parse(fileContext)
            // 如果登录了，就将token存起来
            if (isLogin && token) {
              await this.loadUserInfo({ Authorization: `Bearer ${token}` })
              if (this.user && this.user.id) {
                this.setUserToken(token)
                // 执行登录后的相关初始化操作
                await this.afterLoginFn()
              } else {
                this.setUserToken(null)
                await deleteFile(loginCachePath())
                return false
              }
            } else if (isLogin && !token && inToken) {
              return await this.loginWriteUserToFile(inToken)
            } else {
              this.setUserToken(null)
              await deleteFile(loginCachePath())
              return false
            }
            return !!(isLogin && token)
          }
        }
        return await this.loginWriteUserToFile(inToken)
      } catch (error) {
        console.error(error)
        return false
      }
    },
    async loginWriteUserToFile(token) {
      await this.loadUserInfo({ Authorization: `Bearer ${token}` })
      if (this.user && this.user.id) {
        writeUserToFile({ isLogin: true, token: token, ...this.user }).catch()
        this.setUserToken(token)
        // 执行登录后的相关初始化操作
        await this.afterLoginFn()
        return true
      } else {
        this.setUserToken(null)
      }
      return false
    },

    // 显示web登录弹框
    async showLoginDialog() {
      if (this.platform === 'web' || this.platform === 'cs' || this.softwareCode === 'AppGbr') {
        this.$showLogin()
      } else if (this.platform === 'r') {
        this.$showLogin()
        this.setShowRLoginButton(false)
        await this.$revitClient.ShowLoginDialog()
        const isLogin = await this.checkLogin()
        if (!isLogin) {
          // 忽略登录的页面
          if (this.ignoreLogin) {
            this.$showLogin(false)
          } else {
            // 保留蒙层，将图片、按钮隐去
            this.setShowRLoginButton(true)
          }
        } else {
          // 已登录则关闭登录蒙层
          this.$showLogin(false)
        }
      } else {
        // G插件弹出登录框
        const gLoginUrl = `${process.env.VUE_APP_GJW_PORTAL_URL}/signinForGcs?platform=g&softwareCode=${this.softwareCode}&softwareVersion=${this.softwareVersion}`
        const options = {
          contentWidth: 400,
          contentHeight: 450,
          titleBar: {
            text: '登录',
            showCloseButton: true,
          }
        }
        await CreateBrowser(gLoginUrl, options)
      }
    }
  }
}
